import { z } from 'zod';
import { isExpiresAtDateValid } from '../utils/expiresAt';

// TODO: Port to Zod v4 when possible for better performance (6-14x faster)
// See: https://zod.dev/v4

// Validation constants
export const POPUP_VALIDATION = {
  TITLE_MAX_LENGTH: 150,
  DESCRIPTION_MAX_LENGTH: 255,
} as const;

export const createPopupSchema = z.object({
  title: z
    .string()
    .min(1, 'form.title.error')
    .max(POPUP_VALIDATION.TITLE_MAX_LENGTH, 'form.title.maxLength')
    .transform((val) => val.trim()),

  description: z
    .string()
    .min(1, 'form.description.error')
    .max(POPUP_VALIDATION.DESCRIPTION_MAX_LENGTH, 'form.description.maxLength')
    .transform((val) => val.trim()),

  frequency: z.enum(['once', 'daily'], {
    errorMap: () => ({ message: 'form.frequency.error' }),
  }),

  expires_at: z
    .string()
    .min(1, 'form.expiresAt.error')
    .refine(isExpiresAtDateValid, { message: 'form.expiresAt.mustBeFuture' }),

  title_en: z
    .string()
    .min(1, 'form.titleEn.error')
    .max(POPUP_VALIDATION.TITLE_MAX_LENGTH, 'form.titleEn.maxLength')
    .transform((val) => val.trim()),

  description_en: z
    .string()
    .min(1, 'form.descriptionEn.error')
    .max(POPUP_VALIDATION.DESCRIPTION_MAX_LENGTH, 'form.descriptionEn.maxLength')
    .transform((val) => val.trim()),
});

export type CreatePopupFormData = z.infer<typeof createPopupSchema>;
